/**
 * 「芯を先に」（2026-09-30 console/core-first・通しの確認 docs/teams/console/walkthrough-2026-09-30.md の C1〜C6）の英語。
 * en.ts が `...enCoreFirst` で取り込む（ja.coreFirst.ts が同じキーを全部持つことを型で強制）。
 *
 * WHY 別のファイルか: 同時に動いている console/words-pass が en.ts / ja.ts の言葉を直している。既存のキーの文を書き換えず、
 *   新しいキーをここに足す = 衝突は en.ts / ja.ts の取り込みの 1 行だけで済む。
 * 決め事（MASTER-PLAN §0）: 見出しは場所の名前、本文は何が起きるかだけ。キャッチコピー・比喩を置かない。サービス名は {product}。
 *   金額は差し込み（{amount}）= サーバーの額を画面に直書きしない。CLI の名前は差し込み（cliCommand.ts）
 */
export const enCoreFirst = {
  // C1 ナビ（projectNav.ts）: 既定 OFF の追加の機能（マルチプレイ・X の共有）の見出し。芯（概要〜ログイン方法）には見出しを付けない
  'nav.group.extras': 'Add-ons',

  // C2 概要の「次のステップ」: 最初の一手 = AI エージェントに頼む（見出しはホームと同じ home.c.askTitle・例は components/AskExamples.tsx）
  'overview.ask.body': 'Ask your connected AI agent in your own words. Mention the project name ({name}) so the agent knows which project you mean.',
  'overview.ask.connect': 'Not connected yet? Connect with the copy-paste line on {link}.',
  // リンク先は /connect（2026-10-07 console/connect-again・以前はホーム）= トップバーの入口と同じ名前で呼ぶ
  'overview.ask.connectLink': 'the Connect an AI agent page',
  'overview.byHand': 'If you type it yourself',

  // C3 ホスティングの空の状態: まず頼む（開発用に出て、本番は 1 回聞かれる = MASTER-PLAN §0 の「公開して」の流れ）、その下に CLI の 1 行
  'hosting.empty.ask': 'Ask your AI agent to "publish it". It publishes to your test app first, then asks you once whether to publish to your published app too.',
  'hosting.empty.cli': 'If you type it yourself: {cmd}',

  // C5 メールの確認の完了: 招待クレジットが入ったと分かるときだけ（pages/VerifyEmail.tsx・inviteCode.ts inviteCreditedByVerify）
  'recover.verifiedInvite': '{amount} of invite credit has been added. It can be used for usage fees only.',

  // C6 登録の招待コードの欄: 何が起きるか。額を書かない方は、GET /v1/platform/info に inviteCredit のキーが無い古い本体・読み込み中の文
  'invite.fieldHintCredit':
    'Enter it to get invite credit for usage fees after you confirm your email (right away when you sign up with Google or GitHub).',
  // 2026-09-30 console/invite-fields: platform/info の inviteCredit で額が分かるとき（AuthPage.tsx）。{amount} = サーバーの額（直書きしない）
  'invite.fieldHintAmount':
    'Enter it to get {amount} for usage fees after you confirm your email (right away when you sign up with Google or GitHub).'
};
